import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  overflowBadgeStyles,
  overflowEllipsisStyle,
} from './MultiSelectInput.styles'

interface OverflowBadgeIProps {
  hiddenCount: number
  colorScheme: ColorScheme
}

export const OverflowBadge = ({
  hiddenCount,
  colorScheme,
}: OverflowBadgeIProps) => (
  <Box
    as='span'
    data-overflow-ellipsis=''
    style={overflowEllipsisStyle(hiddenCount)}
  >
    <Box as='span' {...overflowBadgeStyles(colorScheme)}>
      +{hiddenCount || 1}
    </Box>
  </Box>
)
